import { render, staticRenderFns } from "./CalculateProduct.vue?vue&type=template&id=f907de2a&scoped=true"
import script from "./CalculateProduct.vue?vue&type=script&lang=js"
export * from "./CalculateProduct.vue?vue&type=script&lang=js"
import style0 from "./CalculateProduct.vue?vue&type=style&index=0&id=f907de2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f907de2a",
  null
  
)

export default component.exports